export const chartColors = [
    '#4361ee', '#3a0ca3', '#7209b7', '#f72585', 
    '#4cc9f0', '#4895ef', '#560bad', '#b5179e', 
    '#3f37c9', '#ff9e00', '#38b000', '#9d4edd'
  ];
  
  export const defaultLayout = {
    title: {
      text: 'Specialty Competition Ratios',
      font: {
        family: 'var(--font-family)',
        size: 24,
        color: 'var(--color-text)'
      },
      pad: { t: 30, b: 20 }
    },
    xaxis: {
      title: {
        text: 'Year',
        font: {
          family: 'var(--font-family)',
          size: 16,
          color: 'var(--color-text)'
        }
      },
      tickmode: 'linear',
      dtick: 1,
      tickformat: 'd',
      gridcolor: '#e2e8f0',
      fixedrange: true,
      tickfont: {
        size: 18,
        weight: 600
      },
      ticklen: 8,
      tickwidth: 2,
      tickcolor: '#718096'
    },
    yaxis: {
      title: {
        text: 'Competition Ratio',
        font: {
          family: 'var(--font-family)',
          size: 18,
          color: 'var(--color-text)'
        }
      },
      gridcolor: '#e2e8f0',
      fixedrange: true,
      tickfont: {               // added: increase Y tick size
        size: 15
      }
    },
    legend: {
      orientation: 'h',
      xanchor: 'center',
      x: 0.5,
      y: -0.15,
      bgcolor: '#ffffff',
      bordercolor: '#e2e8f0',
      borderwidth: 1,
      borderradius: 8,
      font: {
        family: 'var(--font-family)',
        size: 16,
        color: 'var(--color-text)'
      }
    },
    margin: { t: 80, b: 100, l: 80, r: 40 },
    hovermode: 'closest',
    autosize: true,
    plot_bgcolor: '#ffffff',
    paper_bgcolor: '#ffffff'
  };
  
  export const plotConfig = {
    responsive: true,
    scrollZoom: false,
    displayModeBar: false
  };